// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.1553 1.37402L22.6269 6.84564L21.2127 8.25985L15.7411 2.78824L17.1553 1.37402ZM14.3534 4.20673L19.7945 9.64786L7.39771 22.001L2.00049 22.001L2.00049 16.6038L14.3534 4.20673ZM22.2083 12.8662L15.9647 19.1098L14.5505 17.6956L20.7941 11.452L22.2083 12.8662Z"}}]};

const PenBallFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-ball-filled',
    ref,
    icon: element,
  },
));

PenBallFilledIcon.displayName = 'PenBallFilledIcon';

export default PenBallFilledIcon;
